import { Site } from 'src/app/shared/interfaces/site';

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-site-detail-tilt-drawing',
  templateUrl: './site-detail-tilt-drawing.component.html',
  styleUrls: ['./site-detail-tilt-drawing.component.scss'],
})
export class SiteDetailTiltDrawingComponent {
  @Input() site: Site = {} as Site;
}
